export const firebaseConfig = {
    apiKey: "AIzaSyCTd6Xf9xs1evmv6maSgUmCyJGSUVZSI-8",
    authDomain: "ear-club.firebaseapp.com",
    projectId: "ear-club",
    storageBucket: "ear-club.appspot.com",
    messagingSenderId: "814352139587",
    appId: "1:814352139587:web:5a27262e82193e923d1bf6",
    measurementId: "G-LBNSHHBF3P"
  };